<template>
  <div>
    <h2>Admin</h2>
    <div class="admin">
      <h1>Hello Maria</h1>
      <label for="username">username</label>
      <input type="text" ref="username"/>
      <label for="email">email</label>
      <input type="email" ref="email">
      <button @click="login">login</button>
    </div>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'

export default {
  name: 'AdminHome',
  computed: mapState({
    profile: state => state.profile.user
  }),
  methods: {
    ...mapActions([
      'requestLoginCodeForEmail'
    ]),

    login() {
      const username = this.$refs.username.value
      const email = this.$refs.email.value
      this.requestLoginCodeForEmail({ username, email })
    }
  }
}
</script>
<style lang="scss" scoped>
.admin {}
</style>
